import { useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Leaf, MessagesSquare, ShoppingBag } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader } from "@/components/Common";
import EmailVerifyNotice from "@/components/EmailVerifyNotice";

function QuotaExhausted({ message }) {
  return (
    <div className="space-y-4 px-5 py-10" data-testid="quota-exhausted">
      <p className="eyebrow">Analisi disponibili: 0</p>
      <h1 className="font-serif text-3xl font-semibold text-[#0d2517]" data-testid="quota-exhausted-message">{message}</h1>
      <p className="text-sm text-[#5b6b60]">Puoi continuare a consultare le tue piante e tutte le analisi già presenti nel tuo account.</p>
      <Link to="/acquista" className="btn-primary w-full" data-testid="quota-go-buy"><ShoppingBag size={16} /> ACQUISTA NUOVE ANALISI</Link>
      <Link to="/piante" className="btn-secondary w-full bg-white" data-testid="quota-go-plants"><Leaf size={16} /> LE MIE PIANTE</Link>
      <Link to="/consulenze" className="btn-secondary w-full bg-white" data-testid="quota-go-consultations"><MessagesSquare size={16} /> Consulenze</Link>
    </div>
  );
}

export default function NewAnalysis() {
  const { user } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const started = useRef(false);
  const [blocked, setBlocked] = useState(null);
  const verified = user?.email_verified !== false;
  const ok = verified && user?.consents?.storage?.granted;

  useEffect(() => {
    if (!ok || started.current) return;
    started.current = true;
    api
      .post("/analyses", { plant_id: params.get("pianta") || null })
      .then(({ data }) => navigate(`/analisi/${data.id}`, { replace: true }))
      .catch((e) => {
        if (e?.response?.status === 403 && ok) return setBlocked(errMsg(e));
        toast.error(errMsg(e));
        navigate("/", { replace: true });
      });
  }, [ok, params, navigate]);

  if (!verified) return <div className="px-5 py-10" data-testid="new-analysis-verify-required"><EmailVerifyNotice /></div>;
  if (!ok) return <Navigate to="/consenso" state={{ next: "/analisi/nuova" }} replace />;
  if (blocked) return <QuotaExhausted message={blocked} />;
  return <Loader text="Preparazione dell'analisi…" />;
}
